export const IdComponente = {
    TEXTO: 1,
    RADIO: 2,
    SELECT: 3,
    CHECKBOX: 4,
    DATA: 5,
    PERIODO: 6,
    NUMERICO: 7,
    INTERVALO_NUMERICO: 8,
    INTERVALO_ALFABETICO: 9,
    CPF: 10,
    CNPJ: 11,
} as const;

export type TIdComponente = typeof IdComponente[keyof typeof IdComponente];

export const isComponenteTexto = (idComponente: number): boolean =>
    idComponente === IdComponente.TEXTO || idComponente === IdComponente.CPF || idComponente === IdComponente.CNPJ;
